import { HttpClient, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT } from '@iot-platform/core';
import { CommonApiListResponse, CommonApiRequest, CommonGenericModel, Environment, Filter } from '@iot-platform/models/common';
import { I4BGridOptions } from '@iot-platform/models/grid-engine';
import { Observable } from 'rxjs';

export abstract class AbstractGridApiHandlerService {
  protected readonly environment: Environment = inject(ENVIRONMENT);
  protected readonly http: HttpClient = inject(HttpClient);

  abstract loadGridData(
    options?: Partial<{
      request: CommonApiRequest;
      masterView: string;
      gridOptions: I4BGridOptions;
      filters: Filter[];
      httpParams: HttpParams;
    }>
  ): Observable<CommonApiListResponse<CommonGenericModel>>;
}
